import { render } from "./ui-pin-code.vue?vue&type=template&id=1c869faa&scoped=true&ts=true"
import script from "./ui-pin-code.vue?vue&type=script&lang=ts"
export * from "./ui-pin-code.vue?vue&type=script&lang=ts"

import "./ui-pin-code.vue?vue&type=style&index=0&id=1c869faa&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c869faa"]])

export default __exports__